<template>
  <span v-if="show">
    <router-link
      :to="{ name: 'billing-info', params: { subId: 'current' } }"
      class="btn"
      :class="{
        'btn-warning':
          sysTags.includes('subscription_level:TRIAL') ||
          sysTags.includes('subscription_level:FREE'),
        'btn-info':
          !sysTags.includes('subscription_level:FREE') &&
          !sysTags.includes('subscription_level:TRIAL'),
      }"
    >
      <i class="glyphicon glyphicon-upload" /> {{ text }}
    </router-link>
  </span>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'UpgradeButton',
  props: {
    text: {
      type: String,
      required: false,
      default: 'Upgrade!',
    },
  },
  computed: {
    show() {
      if (
        !this.projectId ||
        this.$route.meta.noProjectOk ||
        this.sysTags.includes('api_science') ||
        this.sysTags.includes('subscription_level:CONTRACT')
      ) {
        this.$emit('show', false);
        return false;
      }
      this.$emit('show', true);
      return true;
    },
    sysTags() {
      if (this.projectId) {
        if (this.projectOrgId) {
          return this.projectOrgTags;
        }
        return this.projectSysTags;
      }
      return [];
    },
    projectId: get('account2/projectId'),
    projectOrgId: get('account2/projects[:projectId].project.org_id'),
    projectOrgTags: get('account2/organizations[:orgId].system_tags'),
    projectSysTags: get('account2/projects[:projectId].project.system_tags'),
    orgId() {
      return this.$route.params.orgId || this.projectOrgId;
    },
  },
};
</script>
